import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { AppRoutes } from '../../../routes/routeConstants/appRoutes';

// Layout route guard — nest the routes it protects inside this route's element.
// CES Admins must pick a client before reaching any module besides Client Manager
// and My Profile, which sit outside this guard in Routers.tsx.
const ClientSelectionGuard = () => {
  const { needsClientSelection } = useAuth();

  return needsClientSelection ? <Navigate to={AppRoutes.SELECT_CLIENT} replace /> : <Outlet />;
};

export default ClientSelectionGuard;
